import type { Locale } from 'date-fns';
import enUsLocale from 'date-fns/locale/en-US';

import { formatLong } from './formatLong';
import { localize } from './localize';

/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale.
 * @language Khmer
 * @iso-639-2 khm
 */

/**
 * TODO @azizkamoun: replace enUsLocale implementations with custom, local km implementations necessary for vaccine
 * participant flows
 */
export const kmLocale: Locale = {
  code: 'km',
  formatDistance: enUsLocale.formatDistance,
  formatLong,
  formatRelative: enUsLocale.formatRelative,
  localize,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
};
